import { PromoMap } from './promoAction';

const initialState = {
    isLoading: false,
    refreshPromo: true,
    promoLists: null,
    selectedPromo: {},
    skip: 0,
    limit: 20,
    search: '',
    // Promo Code Usage History State
    isUsageLoading: false,
    usageData: null,
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PromoMap.CREATE_PROMO_START: {
            return { ...state, isLoading: true }
        }
        case PromoMap.CREATE_PROMO_SUCCESS: {
            return { ...state, refreshPromo: true }
        }
        case PromoMap.CREATE_PROMO_ERROR: {
            return { ...state, isLoading: false }
        }
        case PromoMap.GET_ALL_PROMO_START: {
            return { ...state, isLoading: true }
        }
        case PromoMap.GET_ALL_PROMO_SUCCESS: {
            return { ...state, isLoading: false, refreshPromo: false, promoLists: action.payload || {} }
        }
        case PromoMap.GET_ALL_PROMO_ERROR: {
            return { ...state, isLoading: false, refreshPromo: false }
        }
        case PromoMap.UPDATE_PROMO_START: {
            return { ...state, isLoading: true }
        }
        case PromoMap.UPDATE_PROMO_SUCCESS: {
            return { ...state, refreshPromo: true, selectedPromo: { ...state.selectedPromo, ...action.payload } }
        }
        case PromoMap.UPDATE_PROMO_ERROR: {
            return { ...state, isLoading: false }
        }
        case PromoMap.DELETE_PROMO_START: {
            return { ...state, isLoading: false }
        }
        case PromoMap.DELETE_PROMO_SUCCESS: {
            return { ...state, isLoading: false, refreshPromo: true }
        }
        case PromoMap.DELETE_PROMO_ERROR: {
            return { ...state, isLoading: false }
        }
        case PromoMap.SET_SELECTED_PROMO: {
            return { ...state, selectedPromo: action.payload }
        }
        case PromoMap.SET_PROMO_BATCH_NUMBER: {
            return { ...state, skip: action.payload }
        }
        case PromoMap.SET_PROMO_SEARCH_CHANGE: {
            return { ...state, search: action.payload }
        }
        case PromoMap.REFRESH_PROMO_LIST: {
            return { ...state, skip: 0, refreshPromo: true }
        }
        
        // Promo Code Usage History Cases
        case PromoMap.GET_PROMO_USAGE_START: {
            return { ...state, isUsageLoading: true, usageData: null }
        }
        case PromoMap.GET_PROMO_USAGE_SUCCESS: {
            return { ...state, isUsageLoading: false, usageData: action.payload }
        }
        case PromoMap.GET_PROMO_USAGE_ERROR: {
            return { ...state, isUsageLoading: false, usageData: null }
        }
        
        default: return { ...state }
    }
} 